export default __webpack_public_path__ + "static/Druid-bd5c89cec562467fc29ed9d79b3f9030.png";